grpnParams = require 'grpn-params'

_constructCollection = (collectionId, collectionType, enabledFacets, extraQS) ->
  collectionsRoot = Groupon.urls.collections if collectionType
  delete extraQS.query

  grpnParams.V1.construct
    baseURL: "#{collectionsRoot}/#{collectionId}"
    l2Categories: enabledFacets['category']
    l3Categories: enabledFacets['category2']
    l4Categories: enabledFacets['category3']
    l5Categories: enabledFacets['category4']
    l6Categories: enabledFacets['category5']
    interests: enabledFacets['interest']
    brands: enabledFacets['brand']
    discounts: enabledFacets['discount']
    extraQS: extraQS

_getAppRoot = ->
  Groupon.urls?.browse ? Groupon.PageAppData?.baseUrl

module.exports = BrowseUrlConstructionHelper =
  constructCollection: _constructCollection

  constructV1: (enabledFacets, extraQS) ->
    appRoot = _getAppRoot()

    grpnParams.V1.construct
      baseURL: appRoot
      l2Categories: enabledFacets['category']
      l3Categories: enabledFacets['category2']
      l4Categories: enabledFacets['category3']
      l5Categories: enabledFacets['category4']
      l6Categories: enabledFacets['category5']
      interests: enabledFacets['interest']
      brands: enabledFacets['brand']
      discounts: enabledFacets['discount']
      extraQS: extraQS

  constructV3: (enabledFacets, extraQS) ->
    appRoot = _getAppRoot()

    permalink = enabledFacets.category5?[0] or
    enabledFacets.category4?[0] or
    enabledFacets.category3?[0] or
    enabledFacets.category2?[0] or
    enabledFacets.category?[0] or 'all'

    grpnParams.V3.construct appRoot, permalink, extraQS

  # TODO: upgrade PhantomJS or find some other .bind alternative
  getConstructCollectionById: (collectionId, collectionType) ->
    (enabledFacets, extraQS) ->
      _constructCollection collectionId, collectionType, enabledFacets, extraQS
